import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const ReactTableSkelton = () => {
  const List = Array.from({ length: 10 }, (_, i) => i + 1);
  const ChildList = Array.from({ length: 5 }, (_, i) => i + 1);
  return (
    <Card className="bg-white flex flex-col gap-3 animate-pulse">
      <Skeleton className="h-[60px] bg-gray-300 rounded-bl-none rounded-br-none" />
      <div className="px-2 py-3 space-y-5">
        {List.map((_, index) => {
          return (
            <div key={index} className="grid grid-cols-5 gap-4">
              {ChildList.map((_, childIndex) => {
                return (
                  <Skeleton key={childIndex} className="h-[20px] bg-gray-300" />
                );
              })}
            </div>
          );
        })}
      </div>
      <Skeleton className="h-[76px] bg-gray-300 rounded-tl-none rounded-tr-none" />
    </Card>
  );
};
